import { render } from "./VQTest.vue?vue&type=template&id=46cf2938&scoped=true&lang=html"
import script from "./VQTest.vue?vue&type=script&lang=js"
export * from "./VQTest.vue?vue&type=script&lang=js"

import "./VQTest.vue?vue&type=style&index=0&id=46cf2938&lang=css&scoped=true"
script.render = render
script.__scopeId = "data-v-46cf2938"

export default script